import { render, staticRenderFns } from "./JobPreviewComment.vue?vue&type=template&id=b52ce6f8"
import script from "./JobPreviewComment.vue?vue&type=script&lang=js"
export * from "./JobPreviewComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports